import axios from 'axios';
import Singleton from '../core/singleton';

const AxiosInstance = axios.create({
    timeout: 6000,
    baseURL: process.env.BASE_URL,
    headers: {
        'Content-Type': "application/json"
    }
});

AxiosInstance.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    let evokedFnName = response.config.data;
    if (evokedFnName === "airportsByIata") {
        let firstLetter = response.data[0].split('')[0];
        if (!Singleton.getInstance().airportsNameStore.lexicalKeyExist(firstLetter)) {
            Singleton.getInstance().airportsNameStore.setLexicalValue(firstLetter, response.data);
        }
    }
    return response;
}, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});


export default AxiosInstance;
